/* eslint-disable import/prefer-default-export */
export { default as useSearch } from './useSearch';
